'use strict';

// Import Libraries
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import screenAndStyle from '../_utils/screen-and-style';
// Import JSX Modules
import MobileSortOption from './mobile-sort-option';
// -----------------------------------------------------------
//  MobileSort
// -----------------------------------------------------------
const MobileSort = ({ value, onChange }) => {
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    if (screenAndStyle.isBootstrapXS()) {
      setCollapsed(true);
    }
  }, []);

  const handleSelection = (option) => {
    onChange(option);
    toggleCollapse();
  };

  const toggleCollapse = () => {
    setCollapsed((prevState) => !prevState);
  };
  const options = [
    {
      value: 'best-sellers',
      title: 'Best sellers',
    },
    {
      value: 'price-low-to-high',
      title: 'Price: low to high',
    },
    {
      value: 'price-high-to-low',
      title: 'Price: high to low',
    },
    {
      value: 'new',
      title: 'New',
    },
    {
      value: 'featured',
      title: 'Featured',
    },
  ];

  const title = options.reduce((memo, option) => {
    return option.value == value ? option.title : memo;
  }, '');

  const renderOptions = () => {
    if (collapsed) {
      return null;
    }

    return (
      <div className="px-4">
        <ul className="list-unstyled">
          {options.map((option, i) => {
            return (<MobileSortOption {...option}
                key={`${i}${value === option.value}`}
                selected={value === option.value}
                onChange={handleSelection} />
              )
            })
          }
        </ul>
      </div>
    );
  };

  return (
    <div className={classNames('options-wrapper d-flex flex-column', { collapsed: collapsed })}>
      <button
        className="btn shelf-filter-dropdown-toggle modal-button d-flex d-flex-row justify-content-between"
        onClick={toggleCollapse}
        aria-label='Sort'
        aria-expanded={!collapsed}
        type='button'>
        Sort by
        <i className={classNames(
          'fa ml-2',
          collapsed ? 'fa-angle-down' : 'fa-angle-up'
        )}></i>
      </button>
      {renderOptions()}
    </div>
  );
};

MobileSort.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default MobileSort;
